/**
 * Format a number based on the locale and options
 * @param number - The number to format
 * @param locale - The locale of the formatted string
 * @param options - The Intl.NumberFormatOptions to use
 * @returns - The formatted number
 */
export const formatNumber = (
  number: number,
  locale: string,
  options: Intl.NumberFormatOptions,
) => {
  const formatter = new Intl.NumberFormat(locale, options)
  return formatter.format(number)
}
